<div class="main tasks-list global-table-wrapper">
    <div class="title-btn">
        <div class="main-title">
            <h1>Task List</h1>
            <p>View and manage your tasks</p>
        </div>
        <div class="new-placement">
            <button
                class="btn btn-action-primary"
                type="button"
                (click)="openAddTask()"
            >
                <i class="fas fa-plus"></i> New Task
            </button>
        </div>
    </div>
    <app-search-filter
        [config]="taskFilterConfig"
        [userId]="userDetail?.id"
        [externalForm]="filterForm"
        placeholder="Filter Tasks..."
        (filter)="onTaskFilterApplied($event)"
        (clear)="onTaskFilterCleared()"
    ></app-search-filter>

    <p-table [value]="tasks" responsiveLayout="scroll" [loading]="loading">
        <ng-template pTemplate="header">
            <tr>
                <th>Title</th>
                <th>Assignee</th>
                <th>Category</th>
                <th>Status</th>
                <th>Farm</th>
                <th>House</th>
                <th>Cycle</th>
                <th>Due</th>
                <th></th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-t>
            <tr>
                <td>{{ t.title }}</td>
                <td>{{ t.assignee || '—' }}</td>
                <td>{{ t.category || t.categoryName || '—' }}</td>
                <td>
                    <span
                        class="status-pill"
                        [class.status-open]="t.status === 'Not Started'"
                        [class.status-inprogress]="t.status === 'In Progress'"
                        [class.status-done]="t.status === 'Completed'"
                        >{{ t.statusName || t.status || '—' }}</span
                    >
                </td>
                <td>{{ t.farm || '—' }}</td>
                <td>{{ t.house || t.houseName || '—' }}</td>
                <td>{{ t.cycle || '—' }}</td>
                <td>{{ t.dueDate | date: 'dd/MM/yyyy' }}</td>
                <td>
                    <a
                        (click)="openViewDetails(t)"
                        pTooltip="View Details"
                        tooltipPosition="top"
                        class="table-action-icon"
                        ><i class="fas fa-eye"></i
                    ></a>
                </td>
                <td>
                    <a
                        (click)="openEditTask(t)"
                        pTooltip="Edit Task"
                        tooltipPosition="top"
                        class="table-action-icon"
                        ><i class="fas fa-edit"></i
                    ></a>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-paginator
        *ngIf="totalRecords > 0"
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
    ></p-paginator>

    <!-- Add Task Dialog -->
    <p-dialog
        [(visible)]="showAddDialog"
        [modal]="true"
        [dismissableMask]="true"
        [closable]="true"
        [position]="'center'"
        [baseZIndex]="3000"
        [blockScroll]="true"
        [appendTo]="'body'"
        [breakpoints]="{'960px': '95vw', '640px': '98vw'}"
        [style]="{width: '900px'}"
        [contentStyle]="{padding: '0', overflow: 'auto', maxHeight: '80vh'}"
    >
        <app-add-task
            [visible]="showAddDialog"
            (closeDialog)="handleCloseAddTask()"
            (taskSaved)="handleTaskSaved($event)"
        ></app-add-task>
    </p-dialog>

    <!-- Edit Task Dialog -->
    <p-dialog
        [(visible)]="showEditDialog"
        [modal]="true"
        [dismissableMask]="true"
        [closable]="true"
        [position]="'center'"
        [baseZIndex]="3000"
        [blockScroll]="true"
        [appendTo]="'body'"
        [breakpoints]="{'960px': '95vw', '640px': '98vw'}"
        [style]="{width: '800px'}"
        [contentStyle]="{padding: '1rem', overflow: 'auto', maxHeight: '80vh'}"
    >
        <div *ngIf="editTaskData" class="edit-task-form">
            <h2>Edit Task</h2>

            <form [formGroup]="editTaskForm" (ngSubmit)="updateTask()">
                <div class="form-grid">
                    <div class="form-group">
                        <label for="taskTitle">Title *</label>
                        <input
                            type="text"
                            id="taskTitle"
                            formControlName="title"
                            class="form-control"
                            required
                        />
                    </div>
                    <div class="form-group full-width">
                        <label>Attachment</label>
                        <div class="attachment-view">
                            <ng-container
                                *ngIf="
                                    editTaskForm.get('attachment')?.value as url
                                "
                            >
                                <a *ngIf="url" [href]="url" target="_blank">{{
                                    fileNameFromUrl(url)
                                }}</a>
                                <span *ngIf="!url" class="muted-text"
                                    >No attachment</span
                                >
                            </ng-container>
                        </div>
                        <div class="attachment-replace">
                            <input
                                type="file"
                                (change)="onEditFileSelected($event)"
                            />
                            <small class="muted-text"
                                >Pick a file to replace the attachment</small
                            >
                        </div>
                    </div>

                    <!-- Farm -->
                    <div class="form-group">
                        <label for="farm">Farm</label>
                        <select
                            id="farm"
                            class="form-control"
                            formControlName="farmId"
                        >
                            <option [ngValue]="null">Select Farm</option>
                            <option
                                *ngFor="let f of farmOptions"
                                [ngValue]="f.value"
                            >
                                {{ f.label }}
                            </option>
                        </select>
                    </div>

                    <!-- House -->
                    <div class="form-group">
                        <label for="house">House</label>
                        <select
                            id="house"
                            class="form-control"
                            formControlName="houseId"
                        >
                            <option [ngValue]="null">Select House</option>
                            <option
                                *ngFor="let h of houseOptions"
                                [ngValue]="h.value"
                            >
                                {{ h.label }}
                            </option>
                        </select>
                    </div>

                    <!-- Cycle -->
                    <div class="form-group">
                        <label for="cycle">Cycle</label>
                        <select
                            id="cycle"
                            class="form-control"
                            formControlName="cycleId"
                        >
                            <option [ngValue]="null">Select Cycle</option>
                            <option
                                *ngFor="let c of cycleOptions"
                                [ngValue]="c.value"
                            >
                                {{ c.label }}
                            </option>
                        </select>
                    </div>

                    <!-- Partition -->
                    <div class="form-group">
                        <label for="partition">Partition</label>
                        <select
                            id="partition"
                            class="form-control"
                            formControlName="partitionId"
                        >
                            <option [ngValue]="null">Select Partition</option>
                            <option
                                *ngFor="let p of partitionOptions"
                                [ngValue]="p.value"
                            >
                                {{ p.label }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="assignee">Assigned To</label>
                        <select
                            id="assignee"
                            formControlName="assignee"
                            class="form-control"
                        >
                            <option value="">Select Assignee</option>
                            <option
                                *ngFor="let assignee of assigneeOptions"
                                [value]="assignee.label"
                            >
                                {{ assignee.label }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="startDate">Start Date *</label>
                        <input
                            type="datetime-local"
                            id="startDate"
                            formControlName="startDate"
                            class="form-control"
                            required
                        />
                    </div>

                    <div class="form-group">
                        <label for="dueDate">Due Date *</label>
                        <input
                            type="datetime-local"
                            id="dueDate"
                            formControlName="dueDate"
                            class="form-control"
                            required
                        />
                    </div>

                    <div class="form-group">
                        <label for="category">Category</label>
                        <select
                            id="category"
                            formControlName="category"
                            class="form-control"
                        >
                            <option value="">Select Category</option>
                            <option
                                *ngFor="let cat of categoryOptions"
                                [value]="cat.label"
                            >
                                {{ cat.label }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="status">Status</label>
                        <select
                            id="status"
                            formControlName="status"
                            class="form-control"
                        >
                            <option value="">Select Status</option>
                            <option
                                *ngFor="let status of statusOptions"
                                [value]="status.label"
                            >
                                {{ status.label }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group full-width">
                        <label for="description">Description</label>
                        <textarea
                            id="description"
                            formControlName="description"
                            class="form-control"
                            rows="3"
                        ></textarea>
                    </div>
                </div>

                <!-- Sub Tasks Editor -->
                <div
                    class="subtasks-editor"
                    *ngIf="editTaskForm.get('subTasks') as stFA"
                >
                    <div class="subtasks-header">
                        <h3>Sub Tasks</h3>
                        <button
                            type="button"
                            class="btn-action mb-3"
                            (click)="addSubTask()"
                        >
                            <i class="fas fa-plus"></i> Add Sub Task
                        </button>
                    </div>
                    <div
                        class="subtask-item"
                        *ngFor="let st of stFA.controls; let i = index"
                        [formGroup]="st"
                    >
                        <div class="form-grid">
                            <div class="form-group">
                                <label>Title</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="title"
                                />
                            </div>
                            <div class="form-group">
                                <label>Assignee</label>
                                <select
                                    class="form-control"
                                    formControlName="assignee"
                                >
                                    <option value="">Select Assignee</option>
                                    <option
                                        *ngFor="let a of assigneeOptions"
                                        [value]="a.label"
                                    >
                                        {{ a.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group full-width">
                                <label>Attachment</label>
                                <div class="attachment-view">
                                    <ng-container
                                        *ngIf="
                                            st.get('subTaskAttachment')
                                                ?.value as url
                                        "
                                    >
                                        <a
                                            *ngIf="url"
                                            [href]="url"
                                            target="_blank"
                                            >{{ fileNameFromUrl(url) }}</a
                                        >
                                        <span *ngIf="!url" class="muted-text"
                                            >No attachment</span
                                        >
                                    </ng-container>
                                </div>
                                <div class="attachment-replace">
                                    <input
                                        type="file"
                                        (change)="
                                            onEditSubTaskFileSelected($event, i)
                                        "
                                    />
                                    <small class="muted-text"
                                        >Pick a file to replace this sub-task
                                        attachment</small
                                    >
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Start Date</label>
                                <input
                                    type="datetime-local"
                                    class="form-control"
                                    formControlName="startDate"
                                />
                            </div>
                            <div class="form-group">
                                <label>Due Date</label>
                                <input
                                    type="datetime-local"
                                    class="form-control"
                                    formControlName="dueDate"
                                />
                            </div>
                            <div class="form-group">
                                <label>Status</label>
                                <select
                                    class="form-control"
                                    formControlName="status"
                                >
                                    <option value="">Select Status</option>
                                    <option
                                        *ngFor="let s of statusOptions"
                                        [value]="s.label"
                                    >
                                        {{ s.label }}
                                    </option>
                                </select>
                            </div>

                            <div class="form-group full-width">
                                <label>Description</label>
                                <textarea
                                    rows="2"
                                    class="form-control"
                                    formControlName="description"
                                ></textarea>
                            </div>
                        </div>
                        <div class="text-right">
                            <button
                                type="button"
                                class="close-btn-secondary small"
                                (click)="removeSubTask(i)"
                            >
                                Remove
                            </button>
                        </div>
                        <hr />
                    </div>
                </div>

                <div class="form-actions text-center">
                    <button
                        type="button"
                        class="close-btn-secondary"
                        (click)="closeEditDialog()"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        class="btn-action-primary"
                        [disabled]="!editTaskForm.valid || loading"
                    >
                        {{ loading ? 'Updating...' : 'Update Task' }}
                    </button>
                </div>
            </form>
        </div>
    </p-dialog>

    <!-- View Task Details Dialog -->
    <p-dialog
        [(visible)]="showViewDialog"
        [modal]="true"
        [dismissableMask]="true"
        [closable]="true"
        [position]="'center'"
        [baseZIndex]="3000"
        [blockScroll]="true"
        [appendTo]="'body'"
        [breakpoints]="{'960px': '95vw', '640px': '98vw'}"
        [style]="{width: '800px'}"
        [contentStyle]="{padding: '2rem', overflow: 'auto', maxHeight: '80vh'}"
    >
        <div *ngIf="viewTaskData" class="task-details-content">
            <div class="task-details-header">
                <h2>{{ viewTaskData.title }}</h2>
                <span
                    class="task-status"
                    [class]="
                        viewTaskData.status.toLowerCase().replace(' ', '-')
                    "
                >
                    {{ viewTaskData.status }}
                </span>
            </div>

            <div class="task-details-grid">
                <div class="task-detail-item">
                    <label>Assigned To:</label>
                    <span>{{ viewTaskData.assignee || 'Unassigned' }}</span>
                </div>

                <div class="task-detail-item">
                    <label>Category:</label>
                    <span>{{ viewTaskData.category || 'No category' }}</span>
                </div>

                <div class="task-detail-item date-item">
                    <label>Start Date:</label>
                    <span>{{
                        viewTaskData.startDate | date: 'MMM dd, yyyy h:mm a'
                    }}</span>
                </div>

                <div class="task-detail-item date-item">
                    <label>Due Date:</label>
                    <span>{{
                        viewTaskData.dueDate
                            ? (viewTaskData.dueDate
                              | date: 'MMM dd, yyyy h:mm a')
                            : '-'
                    }}</span>
                </div>

                <div class="task-detail-item">
                    <label>Created By:</label>
                    <span>{{ viewTaskData.createdBy || 'System' }}</span>
                </div>

                <div class="task-detail-item">
                    <label>Cycle:</label>
                    <span>{{ viewTaskData.cycle || '-' }}</span>
                </div>

                <div class="task-detail-item">
                    <label>Farm:</label>
                    <span>{{ viewTaskData.farm || 'Not specified' }}</span>
                </div>

                <div class="task-detail-item">
                    <label>House:</label>
                    <span>{{ viewTaskData.house || 'Not specified' }}</span>
                </div>

                <div class="task-detail-item">
                    <label>Partition:</label>
                    <span>{{ viewTaskData.partition || '-' }}</span>
                </div>
            </div>

            <!-- Attachments -->
            <div
                *ngIf="viewTaskData.attachments?.length > 0"
                class="task-attachments"
            >
                <h4>Attachments</h4>
                <div class="attachment-list">
                    <div
                        *ngFor="let attachment of viewTaskData.attachments"
                        class="attachment-item"
                    >
                        <i class="fas fa-paperclip"></i>
                        <a [href]="attachment" target="_blank">{{
                            attachment.split('/').pop()
                        }}</a>
                    </div>
                </div>
            </div>

            <!-- Sub Tasks -->
            <div *ngIf="viewTaskData.subTasks?.length > 0" class="sub-tasks">
                <h4>Sub Tasks</h4>
                <div class="sub-task-list">
                    <div
                        *ngFor="let subTask of viewTaskData.subTasks"
                        class="sub-task-item"
                    >
                        <div class="sub-task-header">
                            <h5>{{ subTask.title }}</h5>
                            <span
                                class="sub-task-status"
                                [class]="
                                    subTask.status
                                        .toLowerCase()
                                        .replace(' ', '-')
                                "
                            >
                                {{ subTask.status }}
                            </span>
                        </div>
                        <div class="sub-task-details">
                            <span
                                ><strong>Assignee:</strong>
                                {{ subTask.assignee }}</span
                            >
                            <span
                                ><strong>Due:</strong>
                                {{ subTask.dueDate | date: 'short' }}</span
                            >
                            <div
                                *ngIf="subTask.description"
                                class="sub-task-description"
                            >
                                <strong>Description:</strong>
                                {{ subTask.description }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </p-dialog>
</div>
